import MoneyData from '@/atoms/MoneyData';
import Metrics from '@/molecules/Metrics';
import SecondaryTitle from '@/molecules/titles/SecondaryTitle';
import ModalClassicLayout from 'context/Modal/layout/Classic';
import { useTranslation } from 'react-i18next';
import usePayoutModal from './hooks';
import OptionTile from '@/atoms/OptionTile';
import HistoryCartDetail from './HistoryCartDetail';
import AlertTool from '@/molecules/AlertTool';
import { VARIANT_COLOR_ENUM } from '@/types/utils';

type Props = {
  closeModal: () => void;
};

const PayoutModal = ({ closeModal }: Props) => {
  const { t } = useTranslation();

  const { marketplaceBalance, currency, bankAccount, postPayout, payoutDetail } = usePayoutModal();

  const bankAccountIdDisplay = bankAccount?.IBAN || bankAccount?.id || '';

  const isSubmitEnabled =
    bankAccount && marketplaceBalance > 0 && payoutDetail && payoutDetail.total && payoutDetail.total > 0;

  return (
    <ModalClassicLayout
      closeModal={closeModal}
      isSubmitDisabled={!isSubmitEnabled}
      onSubmit={() => postPayout()}
      submitLabel={t('confirm-transfer')}
      title="wallet.payoutModal.titlle"
    >
      <div className="flex flex-col gap-4">
        {!isSubmitEnabled && payoutDetail && (
          <AlertTool variant={VARIANT_COLOR_ENUM.ERROR}>{t('wallet.transfer.toomanyfees.warning')}</AlertTool>
        )}
        <Metrics icon="fa-solid fa-coins" subLine={t('wallet.sales.gain.label')}>
          <MoneyData amount={marketplaceBalance} currency={currency} />
        </Metrics>
        <SecondaryTitle showLine>{t('wallet.payoutModal.amount')}</SecondaryTitle>
        <HistoryCartDetail data={payoutDetail} title={t('details')} />
        <p className="col-span-2 md-regular text-neutral-800">{t('payout.description.details')}</p>

        <SecondaryTitle showLine>{t('payout-bank-account')}</SecondaryTitle>
        <OptionTile
          data-testid="user-bank-tile"
          description={bankAccountIdDisplay}
          icon="fa-regular fa-bank"
          label={bankAccount?.ownerName ? bankAccount.ownerName : t('user-bank-account')}
        />
      </div>
    </ModalClassicLayout>
  );
};

export default PayoutModal;
